module.exports = __webpack_public_path__ + "img/tape-hits-sign.b45002d8.png";